import { PaintedScene } from '../PaintedScene';

export const COTTAGE_CREST_GOLDEN_PHASER_KEY = 'CottageCrestGoldenScene' as const;
export const COTTAGE_CREST_GOLDEN_MANIFEST_KEY = 's-002-cottage-crest-golden' as const;

export class CottageCrestGoldenScene extends PaintedScene {
  constructor() {
    super(COTTAGE_CREST_GOLDEN_PHASER_KEY, COTTAGE_CREST_GOLDEN_MANIFEST_KEY);
  }
}
